import { FC, useEffect, useState } from "react";
import { Loading } from "../../../components/Loading";
import "./index.css";
import { usePluginspace } from "../../../hooks/usePluginspace";
import useAuth from "../../../hooks/useAuth";
import api from "../../../services/api";
import { AddressCard } from "../../../components/Address/addressCard";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAppConfig } from "../../../hooks/useAppConfig"; // <-- Adicionado

export type address = {
  id: number;
  customerId: number;
  typeAddress: string;
  street: string;
  number: string;
  district: string;
  complement: string;
  city: string;
  extra?: string;
  state: string;
  zipCode: string;
  ibgeCode: string;
  latlng?: any;
  placeId?: string;
  created?: string;
  updated?: string;
};

const AddressesIndex: FC = () => {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState<address[]>([]);
  const navigate = useNavigate();

  const { getToken } = usePluginspace();
  const { loginInfo } = useAuth();

  // Estados para a Cor Primária
  const { getAppConfig } = useAppConfig();
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const conf = await getAppConfig();
        if (conf?.webappcolor?.webappbutton) {
          setPrimaryColor(conf.webappcolor.webappbutton);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchConfig();
  }, []);

  const loadAddresses = async () => {
    if (loginInfo.identifier) {
      setLoading(true);

      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: loginInfo.identifier,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response: any) => {
          setLoading(false);
          if (response.data.data.length > 0) {
            const data = response.data.data[0];
            setAddresses(data.customerAddresses);
          }
        })
        .catch((err: any) => {
          setLoading(false);
          console.log(err);
        });
    }
  };

  const cadastrarAddress = () => {
    navigate("create");
  };

  const deleteAddress = async (addressId: number) => {
    setLoading(true);
    try {
      await api
        .delete(`/api/customer/address/${loginInfo.id}/${addressId}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response: any) => {
          setLoading(false);

          if (response.data.success) {
            Swal.fire({
              icon: "success",
              title: "Sucesso!",
              text: "Endereço deletado com sucesso",
              confirmButtonColor: primaryColor,
            });
            const newAddress = addresses.filter((el) => el.id !== addressId);
            setAddresses(newAddress);
          } else {
            Swal.fire({
              icon: "warning",
              title: "Erro!",
              text: "Não foi possível excluir esse endereço!",
              confirmButtonColor: primaryColor,
            });
          }
        })
        .catch((err: any) => {
          setLoading(false);
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Ocorreu um erro ao tentar se comunicar com o servidor.",
            confirmButtonColor: primaryColor,
          });
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    loadAddresses();
  }, [loginInfo.identifier]);

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "#FFF",
            zIndex: 10,
          }}
        >
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="perfil-address-content">
          <div className="perfil-address-header">
            <h4>Endereços cadastrados</h4>
          </div>

          <div className="perfil-address-list">
            {addresses.map((add) => (
              <AddressCard
                key={add.id}
                data={add}
                deleteAddress={deleteAddress}
              />
            ))}
          </div>

          <button
            className="perfil-address-btn"
            style={{ background: primaryColor }}
            onClick={() => cadastrarAddress()}
          >
            Adicionar endereço
          </button>
        </div>
      )}
    </>
  );
};

export { AddressesIndex };
